<template>
	<v-container fluid class="fill-height">
		<v-row justify="center">
			<v-dialog v-model="dialog" persistent max-width="1000px">
				<v-card class="custom_card">
					<v-card-title>
						<v-container fluid>
							<span class="headline" v-html="title"></span>
						</v-container>
					</v-card-title>
					
					<v-card-text>
						<v-container fluid>
							<v-form autocomplete="off">
								<v-row dense>
									
									<slot name="formFields"></slot>
								
								</v-row>
							</v-form>
						</v-container>
					</v-card-text>
					
					<v-card-actions>
						<v-container fluid>
							<v-row class="text-right" dense>
								<v-col>
									<v-btn @click="$emit('close')" color="primary" class="mr-2">Close</v-btn>
									<v-btn @click="$emit('submit')" color="primary">Submit</v-btn>
								</v-col>
							</v-row>
						</v-container>
					</v-card-actions>
				</v-card>
			</v-dialog>
		</v-row>
	</v-container>
</template>

<script>
    export default {
        components: {},
        props: {
            dialog: {
                type: Boolean,
                default: false,
            },
            title: {
                type: String,
                default: 'Title'
            }
        }
    };
</script>
